import React from 'react';
import { Headset, BadgeCheck } from 'lucide-react';
import 'aos/dist/aos.css';

const AboutUs = () => {
  return (
    <section className="py-20 px-6 md:px-10" style={{ backgroundColor: "#F1F0EA", color: "#534B52" }}>
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div data-aos="fade-up" className="mb-12 text-center">
          <h2 className="text-4xl font-bold mb-4" style={{ color: "#474448" }}>
          CED / ED / KTL Coating Process
          </h2>
          <p className="text-xl" style={{ color: "#534B52" }}>
          Electrifying Protection with Superior Coverage and Durability
          </p>
        </div>

        {/* Company Overview */}
        <div data-aos="fade-up" className="mb-16 text-lg leading-relaxed">
          <p>
          We are a cutting-edge powder coating company in the Indian market, offering top-tier expertise in our services. Powder coating is an eco-friendly, pollution-free, and solvent-free process used to apply dry paint. This coating technique involves applying a free-flowing dry powder, which creates a durable, erosion-resistant, and tough finish. It is also less harmful to the environment. Powder coating is ideal for a variety of building materials, including windows, doors, furniture, and modular cabins.


          </p>
        </div>

        {/* Highlights with Icons */}
       
      </div>
    </section>
  );
};

export default AboutUs;
